const webImages = {
  webDevImg:  "http://flaticons.net/gd/makefg.php?i=icons/Wildlife/Web.png&r=18&g=255&b=255",
  mktImg:  "http://flaticons.net/gd/makefg.php?i=icons/Shopping/Dollar-Tag.png&r=241&g=90&b=36",
  designImg: "http://flaticons.net/gd/makefg.php?i=icons/User%20Interface/Palette.png&r=41&g=255&b=25",
  star: "http://flaticons.net/gd/makefg.php?i=icons/Shapes/Shape-Star2.png&r=241&g=90&b=36",
  heroku: "http://gathr-app.herokuapp.com/images/gathrall.png",
}

export default webImages



// WEBPACK FOOTER //
// ./src/components/images.js